import React from 'react';
import Text, { TextTypes } from '../../Text';

const SingleColor = ({ styles, colorName, colorValue }) => (
    <div className={styles.container}>
        <div className={styles.singleColor}></div>
        <Text type={TextTypes.SMALL}>@{colorName}</Text>
        <Text type={TextTypes.SMALL}>{colorValue}</Text>
    </div>
);

export default SingleColor;
